module.exports = __webpack_public_path__ + "img/bg_buy.a00ad86c.png";